import Vue from 'vue'
import EventAnalytics from '../utils/events'

Vue.prototype.$analytics = new EventAnalytics()
